<div class="assessment">
  
  <lib-content-loader *ngIf="loading"></lib-content-loader>
  
  <div>
    @if (questions && !loading) {

      <app-question 
        *ngFor="let question of questions.questions; index as index" 
        [overlay]="!(index === 0)"
        [attr.data-testid]="'assessment-question-' + index">
  
        @if (question.answer_ui_type == 'Single Choice') {
          <app-single-choice [question]="question" [token]="token" (onNext)="scrollTo(index)"></app-single-choice>
        }
  
        @if (question.answer_ui_type == 'Free Text') {
          <app-text [question]="question" [token]="token" (onNext)="scrollTo(index)"></app-text>
        }
  
        @if (question.answer_ui_type == 'Ranking') {
          <app-ranking [question]="question" [token]="token" (onNext)="scrollTo(index)"></app-ranking>
        }

        @if (index === questions.questions.length - 1 ) {
          <lib-button class="button" color="accent" 
            (click)="complete()" data-testid="assessment-submit-button">Submit
          </lib-button>
        }

      </app-question>
  
    } @else if (!loading && !questions) {
      <div data-testid="assessment-invalid-token">Invalid token please contact your admin</div>
    }
  </div>

  @if (questions && !loading) {
    <app-status-bar 
      [questions]="questions.questions"
      [total_answered]="total_answered"
      (onComplete)="complete()">
    </app-status-bar>
  }
</div>


